/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 const mySwiper = new Swiper('.swiper', {
    slidesPerView: '5',
    breakpoints: {
      600: {
        loop: true,
        slidesPerView: '2',

      }
    },
  });

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

(function() {
  // カートページ以外では何もしない
  if (!window.theme || window.theme.pageType !== 'cart') {
    return;
  }

  function normalizeBoolean(value) {
    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'string') {
      return value.toLowerCase() === 'true';
    }

    return false;
  }

  function normalizeShopCodes(value) {
    if (Array.isArray(value)) {
      return value;
    }

    if (typeof value !== 'string') {
      return [];
    }

    var trimmedValue = value.trim();

    if (!trimmedValue) {
      return [];
    }

    if (trimmedValue.charAt(0) === '[') {
      try {
        var parsedValue = JSON.parse(trimmedValue);
        return Array.isArray(parsedValue) ? parsedValue : [];
      } catch (error) {
        console.error('[shop-staff] invalid store_code JSON:', trimmedValue, error);
        return [];
      }
    }

    return [trimmedValue];
  }

  function parseStaffData() {
    var dataScript = document.getElementById('shop-staff-data');

    if (!dataScript) {
      return [];
    }

    try {
      var rawStaff = JSON.parse(dataScript.textContent || '[]');

      return rawStaff
        .filter(function(staff) {
          return normalizeBoolean(staff.active);
        })
        .map(function(staff) {
          return {
            code: staff.code,
            name: staff.name,
            shopCodes: normalizeShopCodes(staff.shopCodes),
            sortOrder: Number(staff.sortOrder) || 0
          };
        });
    } catch (error) {
      console.error('[shop-staff] failed to parse staff data:', error);
      return [];
    }
  }

  function initShopStaffSelector() {
    var container = document.getElementById('shop-staff_select');

    if (!container) {
      return;
    }

    if (container.dataset.initialized === 'true') {
      return;
    }

    var shopSelect = document.getElementById('shop-list');
    var staffSelect = document.getElementById('staff-list');
    var termsPolicy = document.getElementById('terms_policy');
    var termsPolicy2 = document.getElementById('terms_policy2');
    var checkoutBtn = document.getElementById('Cart__checkout__button');

    if (!shopSelect || !staffSelect || !termsPolicy || !termsPolicy2 || !checkoutBtn) {
      return;
    }

    var allStaff = parseStaffData();
    var cartShopCode = container.dataset.cartShopCode || '0';
    var cartStaffCode = container.dataset.cartStaffCode || '0';

    function updateCheckoutBtn() {
      var shopVal = shopSelect.value;
      var staffVal = staffSelect.value;
      var termsChecked = termsPolicy.checked;
      var terms2Checked = termsPolicy2.checked;

      checkoutBtn.disabled = !(shopVal !== '0' && staffVal !== '0' && termsChecked && terms2Checked);
    }

    function changeShop() {
      var shopCode = shopSelect.value;

      staffSelect.innerHTML = '<option value="0" selected>選択してください</option>';

      if (shopCode === '0') {
        staffSelect.disabled = true;
        return;
      }

      var matchedStaff = allStaff
        .filter(function(staff) {
          return staff.shopCodes.indexOf(shopCode) !== -1;
        })
        .sort(function(a, b) {
          return a.sortOrder - b.sortOrder;
        });

      staffSelect.disabled = matchedStaff.length === 0;

      matchedStaff.forEach(function(staff) {
        var option = document.createElement('option');
        option.value = staff.code;
        option.textContent = staff.name;

        if (cartShopCode === shopCode && cartStaffCode === staff.code) {
          option.selected = true;
        }

        staffSelect.appendChild(option);
      });
    }

    function persistCartAttributes() {
      var shopVal = shopSelect.value;
      var staffVal = staffSelect.value;

      updateCheckoutBtn();

      if (shopVal === '0' || staffVal === '0') {
        return;
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            '店舗名': shopVal,
            '担当者': staffVal
          }
        })
      })
        .then(function(response) {
          if (!response.ok) {
            console.error('[cart/update.js] HTTP error:', response.status);
          }
          return response.json();
        })
        .catch(function(error) {
          console.error('[cart/update.js] error:', error);
        });
    }

    shopSelect.addEventListener('change', function() {
      changeShop();
      persistCartAttributes();
    });
    staffSelect.addEventListener('change', persistCartAttributes);
    termsPolicy.addEventListener('change', updateCheckoutBtn);
    termsPolicy2.addEventListener('change', updateCheckoutBtn);

    if (cartShopCode !== '0') {
      shopSelect.value = cartShopCode;
      changeShop();
    }

    updateCheckoutBtn();
    container.dataset.initialized = 'true';
  }

  var debounceTimer = null;
  var observer = new MutationObserver(function() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(initShopStaffSelector, 100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopStaffSelector);
  } else {
    initShopStaffSelector();
  }

  // 監視対象を cart section に限定（空カートでも常に存在する）
  var cartSection = document.querySelector('[data-section-type="cart"]');
  if (cartSection) {
    observer.observe(cartSection, { childList: true, subtree: true });
  }
})();
